import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState, useRef } from 'react';
import moment from 'moment';
import { DABInlineLoading } from '.';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { azureAction } from '../../actions/azureAction';

interface IUserProps {
	dispatch: Dispatch<any>;
	azureData: any;
}

const UserMetrics: React.SFC<IUserProps> = ({ dispatch, azureData }) => {

	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [graphOptions, setGraphOptions] = useState({});
	const chartComponentRef = useRef(null);

	const handleRefreshGraph = (data, time) => {
		setGraphOptions({
			chart: {
				type: 'column'
			},
			title: {
				text: ' '
			},
			xAxis: {
				categories: time
			},
			yAxis: {
				min: 0,
				title: {
					text: 'Number Of Users'
				}
			},
			plotOptions: {
				series: {
					allowPointSelect: false,

				}
			},
			series: [{
				name: 'Users ',
				data: [...data],
				dataLabels: {
					enabled: false,
				},
			}]

		});
	};

	React.useEffect(() => {
		dispatch(azureAction.getUserUsageMetric());
	}, []);

	if (!isDataLoaded && azureData && !azureData.isLoading && azureData.isSuccess) {
		setIsDataLoaded(true);
		if (azureData.items.length > 0) {
			var data: number[] = [];
			var time: string[] = [];
			azureData.items.forEach((item) => {
				const localTime = moment.utc(item.dateTime).local() // Convert from UTC to local browser time
				data.push(item.users)
				time.push(moment(localTime).format('hh A'))
			});
			handleRefreshGraph(data, time);
		}
	}

	return (
		<div className="azure-user-metric">
			<h5 data-testid="userMetricsTitle">User Usage Metrics</h5>
			<div className='card-box'>
				<div className='card-box-graph' data-testid="userMetricsChart">
					{azureData && azureData.isLoading ? <DABInlineLoading /> :
						azureData && azureData.items && azureData.items.length > 0 ?
							<HighchartsReact
								containerProps={{ style: { height: "100%", width: "100%", padding: "0" } }}
								highcharts={Highcharts}
								options={graphOptions}
								ref={chartComponentRef}
							/> :
							<div className="card-box on-empty"><h5 className="text-center">No data found</h5></div>}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { azureData } = state;
	return { azureData };
};

export default connect(mapStateToProps)(UserMetrics);